window.addEventListener('scroll', function() {
    // .fade-in クラスを持つ要素をすべて取得
    const fadeIns = document.querySelectorAll('.fade-in');

    fadeIns.forEach(function(element) {
        // 要素の位置を取得
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const windowHeight = window.innerHeight;

        // スクロール位置が要素の位置を超えたら .active クラスを追加
        if (window.scrollY > elementPosition - windowHeight + 300) {
            element.classList.add('active');
        }
    });
});



